export default __webpack_public_path__ + "static/media/Thrice-Howled Edge of Frenzy.e3c52a5e.jpg";